export const TODOS_EMPREENDIMENTOS_VALUE = "TODOS_EMPREENDIMENTOS";

function firstDefined(item, keys, fallback = "") {
  for (const key of keys) {
    if (item?.[key] !== undefined && item?.[key] !== null && String(item[key]).trim() !== "") {
      return item[key];
    }
  }

  return fallback;
}

const VALUE_KEYS_BY_MODE = {
  codigoEmpresa: [
    "codigoEmpresaErp",
    "codigo_empresa_erp",
    "codigoEmpresa",
    "codigo_empresa",
    "idClienteEmpresa",
    "id_cliente_empresa",
    "idEmpresa",
    "id_empresa",
    "id",
  ],
  idEmpresa: [
    "idClienteEmpresa",
    "id_cliente_empresa",
    "idEmpresa",
    "id_empresa",
    "id",
    "codigoEmpresaErp",
    "codigo_empresa_erp",
    "codigoEmpresa",
    "codigo_empresa",
  ],
};

export function getEmpreendimentoFilterValue(item, mode = "codigoEmpresa") {
  return String(
    firstDefined(
      item,
      VALUE_KEYS_BY_MODE[mode] || VALUE_KEYS_BY_MODE.idEmpresa,
      ""
    )
  ).trim();
}

export function getEmpreendimentoLabel(item, fallbackId) {
  return (
    firstDefined(item, [
      "nomeEmpresa",
      "nome_empresa",
      "empresaArquivo",
      "empresa_arquivo",
      "nomeObra",
      "nome_obra",
      "obraArquivo",
      "obra_arquivo",
      "codigoObraErp",
      "codigo_obra_erp",
    ]) || `Empreendimento ${fallbackId}`
  );
}

export function normalizeEmpreendimentoContext(item) {
  if (!item) {
    return null;
  }

  return {
    idClienteEmpresa: firstDefined(item, ["idClienteEmpresa", "id_cliente_empresa"], ""),
    codigoEmpresaErp: firstDefined(item, ["codigoEmpresaErp", "codigo_empresa_erp", "codigoEmpresa", "codigo_empresa"], ""),
    nomeEmpresa: firstDefined(item, ["nomeEmpresa", "nome_empresa"], ""),
    empresaArquivo: firstDefined(item, ["empresaArquivo", "empresa_arquivo"], ""),
    idClienteObra: firstDefined(item, ["idClienteObra", "id_cliente_obra"], ""),
    codigoObraErp: firstDefined(item, ["codigoObraErp", "codigo_obra_erp", "codigoObra", "codigo_obra"], ""),
    nomeObra: firstDefined(item, ["nomeObra", "nome_obra"], ""),
    obraArquivo: firstDefined(item, ["obraArquivo", "obra_arquivo"], ""),
  };
}

export function getEmpreendimentoSelectionKey(item) {
  return String(
    firstDefined(item, [
      "idClienteEmpresa",
      "id_cliente_empresa",
      "idEmpresa",
      "id_empresa",
      "codigoEmpresaErp",
      "codigo_empresa_erp",
      "codigoEmpresa",
      "codigo_empresa",
      "id",
    ], "")
  ).trim();
}

export function findEmpreendimentoByFilterValue(empreendimentos = [], value, mode = "codigoEmpresa") {
  if (!value || isTodosEmpreendimentos(value)) {
    return null;
  }

  const normalizedValue = String(value).trim();
  return empreendimentos.find((item) => getEmpreendimentoFilterValue(item, mode) === normalizedValue) || null;
}

export function buildEmpreendimentoOptions(empreendimentos = [], { valueMode = "codigoEmpresa" } = {}) {
  const optionsByValue = new Map();

  empreendimentos.forEach((item) => {
    const value = getEmpreendimentoFilterValue(item, valueMode);
    if (!value || optionsByValue.has(value)) {
      return;
    }

    optionsByValue.set(value, {
      value,
      label: getEmpreendimentoLabel(item, value),
      selectionKey: getEmpreendimentoSelectionKey(item),
      context: normalizeEmpreendimentoContext(item),
    });
  });

  return [
    { value: TODOS_EMPREENDIMENTOS_VALUE, label: "Todos Empreendimentos" },
    ...Array.from(optionsByValue.values()),
  ];
}

export function isTodosEmpreendimentos(value) {
  return value === TODOS_EMPREENDIMENTOS_VALUE;
}

export function buildEmpresaFilterParams(value, paramName = "empresa") {
  return value && !isTodosEmpreendimentos(value) ? { [paramName]: value } : {};
}
